<template>
    <div class="modal fade" ref="modal" data-bs-backdrop="static" tabindex="-1" aria-labelledby="erkModalLabel"
        aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">ATTENZIONE</h5>

                    <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                        aria-label="Close">
                        <!--begin::Svg Icon | path: icons/duotone/Navigation/Close.svg-->
                        <span class="svg-icon svg-icon-2x">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)"
                                    fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1"></rect>
                                    <rect fill="#000000" opacity="0.5"
                                        transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)"
                                        x="0" y="7" width="16" height="2" rx="1"></rect>
                                </g>
                            </svg>
                        </span>
                        <!--end::Svg Icon-->
                    </div>
                </div>
                <div class="modal-body">
                    <div v-if="isLoading">

                    </div>
                    <div v-else v-html="message">
                    </div>
                </div>
                <div v-if="!isLoading" class="modal-footer">
                    <button @click="onClickOk()" type="button" class="btn btn-primary close-btn">
                        Ok
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        userId: Number
    },
    data() {
        return {
            isLoading: false,
            message: '',
            onClickOkHandler: null,
            myModal: null
        }
    },
    beforeUnmount() {
        if (this.myModal) {
            this.myModal.dispose()
        }
    },
    methods: {
        show(message, onClickOkHandler) {
            this.message = message
            this.onClickOkHandler = onClickOkHandler

            this.toggle()
        },
        toggle() {
            if (this.myModal == null) {
                this.myModal = new window.bootstrap.Modal(this.$refs.modal)
            }
            this.myModal.toggle()
        },
        onClickOk() {
            if (this.onClickOkHandler) {
                this.onClickOkHandler()
            }
            this.toggle()
        }
    }
}
</script>